import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const skills = [
  // --- Existing skills ---
  {
    name: "Python",
    level: 80,
    iconClass: "devicon-python-plain",
    gradient: "linear-gradient(90deg, #3776ab 0%, #6dc7ef 100%)"
  },
  {
    name: "R",
    level: 82,
    gradient: "linear-gradient(90deg, #276dc3 0%, #6e9cea 100%)",
    imgSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/r/r-original.svg"
  },
  {
    name: "SQL",
    level: 75,
    iconClass: "bi bi-database-fill",
    gradient: "linear-gradient(90deg, #f29111 0%, #e8700c 100%)"
  },
  {
    name: "Machine Learning",
    level: 85,
    iconClass: "bi bi-robot",
    gradient: "linear-gradient(90deg, #55b5aa 0%, #3bba9c 100%)"
  },
  {
    name: "PowerBI",
    level: 68,
    iconClass: "bi bi-bar-chart-fill",
    gradient: "linear-gradient(90deg, #ffbb00 0%, #ffc83c 100%)"
  },
  {
    name: "SAS",
    level: 80,
    iconClass: "bi bi-bar-chart-line-fill",
    gradient: "linear-gradient(90deg, #178cbe 0%, #00adee 100%)"
  },
  {
    name: "AWS SageMaker",
    level: 87,
    gradient: "linear-gradient(90deg, #4f378b 0%, #8a56c1 100%)",
    imgSrc: "assets/img/SageMaker3.png"
  },
  {
    name: "Docker",
    level: 72,
    iconClass: "devicon-docker-plain",
    gradient: "linear-gradient(90deg, #0db7ed 0%, #1b8ec6 100%)"
  },
  {
    name: "API",
    level: 76,
    iconClass: "bi bi-plug-fill",
    gradient: "linear-gradient(90deg, #9b5de5 0%, #4cc9f0 100%)"
  },
  {
    name: "Streamlit",
    level: 78,
    iconClass: "devicon-streamlit-plain",
    gradient: "linear-gradient(90deg, #ff4b4b 0%, #ff7c7c 100%)"
  },
  {
    name: "Git",
    level: 70,
    iconClass: "bi bi-git",
    gradient: "linear-gradient(90deg, #f14e32 0%, #e04119 100%)"
  },

  // --- New skills ---
  {
    name: "LLM",
    level: 80,
    iconClass: "bi bi-cpu-fill",
    gradient: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)"
  },
  {
    name: "NLP",
    level: 76,
    iconClass: "bi bi-chat-dots-fill",
    gradient: "linear-gradient(90deg, #11998e 0%, #38ef7d 100%)"
  },
  {
    name: "AWS S3",
    level: 80,
    gradient: "linear-gradient(90deg, #e25444 0%, #ff8c69 100%)",
    imgSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg"
  },
  {
    name: "AWS EC2",
    level: 86,
    gradient: "linear-gradient(90deg, #ff6f00 0%, #ffca28 100%)",
    imgSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg"
  },
  {
    name: "AWS Bedrock",
    level: 65,
    iconClass: "bi bi-layers-fill",
    gradient: "linear-gradient(90deg, #232f3e 0%, #4a6fa5 100%)"
  },
  {
    name: "RLHF",
    level: 88,
    iconClass: "bi bi-person-check-fill",
    gradient: "linear-gradient(90deg, #fc466b 0%, #3f5efb 100%)"
  },
  {
    name: "AI for Research",
    level: 87,
    iconClass: "bi bi-search-heart-fill",
    gradient: "linear-gradient(90deg, #f7971e 0%, #ffd200 100%)"
  },
  {
    name: "Deep Reinforcement Learning",
    level: 85,
    iconClass: "bi bi-diagram-3-fill",
    gradient: "linear-gradient(90deg, #a770ef 0%, #cf8bf3 50%, #fdb99b 100%)"
  }
];

function Skills() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section id="skills" className="container py-5" data-aos="fade-right">
      <h2 className="fw-bold mb-4">Skills</h2>
      <div className="row">
        {skills.map((skill, idx) => (
          <div className="col-md-6 mb-4 skill-bar-container" key={skill.name}>
            <div className="d-flex align-items-center mb-1">
              <span
                className="me-2"
                style={{
                  display: "inline-flex",
                  width: 34,
                  height: 34,
                  alignItems: "center",
                  justifyContent: "center",
                  background: skill.gradient,
                  borderRadius: 9,
                  boxShadow: "0 4px 15px rgba(16,40,70,0.07)",
                  flexShrink: 0
                }}
              >
                {skill.imgSrc ? (
                  <img
                    src={skill.imgSrc}
                    alt={skill.name}
                    style={{ width: 22, height: 22, objectFit: "contain" }}
                  />
                ) : (
                  <i
                    className={skill.iconClass}
                    style={{
                      fontSize: 22,
                      color: "#fff",
                      filter: "drop-shadow(0 1px 6px rgba(20,40,70,0.09))"
                    }}
                  />
                )}
              </span>
              <span
                className="fw-semibold"
                style={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                {skill.name}
              </span>
            </div>

            <div
              className="progress skill-bar"
              style={{
                height: "1.3rem",
                background: "rgba(255,255,255,0.08)",
                borderRadius: "8px",
                overflow: "hidden"
              }}
            >
              <div
                className="progress-bar"
                style={{
                  width: "0%",
                  background: skill.gradient,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  letterSpacing: 0.5,
                  transition: "box-shadow 0.3s ease, transform 0.3s ease"
                }}
                role="progressbar"
                aria-valuenow={skill.level}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {skill.level}%
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        /* Fill animation on mount */
        .skill-bar .progress-bar {
          animation: fillBar 1.2s ease-out forwards;
        }

        @keyframes fillBar {
          0%   { width: 0%; }
          100% { width: var(--target-width); }
        }

        /* Assign each bar its target width */
        ${skills.map((s, i) => `
          .skill-bar-container:nth-child(${i + 1}) .skill-bar .progress-bar {
            --target-width: ${s.level}%;
          }
        `).join("")}

        /* Glow on hover — triggered by hovering anywhere in the card row */
        .skill-bar-container:hover .skill-bar .progress-bar,
        .skill-bar-container:focus-within .skill-bar .progress-bar {
          box-shadow:
            0 4px 18px rgba(41,182,246,0.35),
            0 2px 8px rgba(10,20,40,0.28);
          transform: scaleY(1.07);
        }
      `}</style>
    </section>
  );
}

export default Skills;
